/**
 * A doctor in several practices can show appointments from all of them on one calendar
 * (`User.settings.calendarAllPractices`). These helpers decide when that applies and label the
 * bookings that belong to a practice other than the selected one.
 */

const sameId = (a: unknown, b: unknown): boolean =>
  typeof a === 'string' && typeof b === 'string' && a.trim().toLowerCase() === b.trim().toLowerCase();

/** True when the calendar should show every practice: a doctor, in 2+ practices, with the setting on. */
export function showsAllPractices(profile: any, groups: any[] | null | undefined): boolean {
  return profile?.userType === 'doctor'
    && profile?.settings?.calendarAllPractices === true
    && Array.isArray(groups) && groups.length > 1;
}

/** The practice name for a booking from another practice; null for the selected practice's own rows. */
export function otherPracticeName(row: any, selectedGroupId: string | null | undefined, groups: any[] | null | undefined): string | null {
  if (!row?.groupId || !selectedGroupId || sameId(row.groupId, selectedGroupId)) return null;
  return (groups || []).find((g: any) => sameId(g.id, row.groupId))?.name || 'Another practice';
}

/** The practice a row belongs to, from the user's practices. */
export function practiceOf(row: any, groups: any[] | null | undefined): any | null {
  return (groups || []).find((g: any) => sameId(g.id, row?.groupId)) || null;
}
